import { ReactElement, Dispatch } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { PageLoading } from 'components';
import type { AuthStore } from 'services/store/auth/types';
import type { BaseActionStore } from 'services/store/base/types';
import { checkLoadingSelector } from 'services/store/base/selectors';
import authActions from 'services/store/auth/actions/constants';
import { addRedirectParam } from 'services/store/auth/actions/actionCreators';
import { locations } from 'services/routes/locations';
import { Action } from '../../../store/types';

const PrivateRoute = ({
  children,
  auth,
  isLoading,
  addRedirect,
}: {
  children: ReactElement;
  auth: AuthStore;
  isLoading: boolean;
  addRedirect: (redirectTo: string) => void;
}) => {
  const location = useLocation();
  const { isLoggedIn } = auth;

  if (isLoading) {
    return <PageLoading />;
  }

  if (!isLoggedIn) {
    addRedirect(location.pathname);
    return <Navigate to={locations.general.login.pathname} />;
  }

  return children;
};

const mapStateToProps = ({
  base,
  auth,
}: {
  base: BaseActionStore;
  auth: AuthStore;
}) => ({
  auth,
  isLoading: checkLoadingSelector(base, [authActions.LOGIN_TO_APP]),
});

const mapDispatchToProps = (
  dispatch: Dispatch<
    Action<{
      to: string;
      actionRequired: boolean;
      hash?: string;
    }>
  >
) => ({
  addRedirect: (redirectTo: string): void => {
    dispatch(addRedirectParam({ to: redirectTo, actionRequired: false }));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PrivateRoute);
